var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgOutlook = function SvgOutlook(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "outlook-1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.411,
    height: 45.411,
    viewBox: "0 0 45.411 45.411",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0364b8;\n      }\n\n      .cls-2, .cls-8 {\n        fill: #0a2767;\n      }\n\n      .cls-3 {\n        fill: #28a8ea;\n      }\n\n      .cls-4 {\n        fill: #0078d4;\n      }\n\n      .cls-5 {\n        fill: #50d9ff;\n      }\n\n      .cls-6 {\n        fill: none;\n      }\n\n      .cls-7 {\n        fill: #064a8c;\n      }\n\n      .cls-8 {\n        opacity: 0.5;\n      }\n\n      .cls-9 {\n        fill: #1490df;\n      }\n\n      .cls-10 {\n        opacity: 0.05;\n      }\n\n      .cls-11 {\n        opacity: 0.1;\n      }\n\n      .cls-12 {\n        opacity: 0.2;\n      }\n\n      .cls-13 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4359",
    "data-name": "Path 4359",
    className: "cls-1",
    d: "M36.39,2h-24.4A1.992,1.992,0,0,0,10,3.992V6.257l13.751,4.257L38.382,6.257V3.992A1.992,1.992,0,0,0,36.39,2Z",
    transform: "translate(4.191 0.838)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4360",
    "data-name": "Path 4360",
    className: "cls-2",
    d: "M41.562,20.927a16.094,16.094,0,0,0,.5-1.994.945.945,0,0,0-.473-.817l-.018-.011-.006,0L26.181,9.34a2.133,2.133,0,0,0-2.3,0L8.5,18.1l-.006,0-.017.01A.945.945,0,0,0,8,18.933a16.1,16.1,0,0,0,.5,1.994L24.8,32.855Z",
    transform: "translate(3.353 3.772)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4361",
    "data-name": "Path 4361",
    className: "cls-3",
    d: "M27.781,5H17.847L14.979,9.257l2.868,4.257,9.934,8.515H36.3V13.515Z",
    transform: "translate(6.278 2.095)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4362",
    "data-name": "Path 4362",
    className: "cls-4",
    d: "M10,5h9.934v8.515H10Z",
    transform: "translate(4.191 2.095)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4363",
    "data-name": "Path 4363",
    className: "cls-5",
    d: "M24,5h8.515v8.515H24Z",
    transform: "translate(10.058 2.095)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4364",
    "data-name": "Path 4364",
    className: "cls-1",
    d: "M29.867,19.515,19.934,11H10v8.515l9.934,8.515,15.372,2.509Z",
    transform: "translate(4.191 4.61)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4365",
    "data-name": "Path 4365",
    className: "cls-6",
    d: "M10.031,5H38.369",
    transform: "translate(4.204 2.095)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4366",
    "data-name": "Path 4366",
    className: "cls-4",
    d: "M17,11h9.934v8.515H17Z",
    transform: "translate(7.125 4.61)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4367",
    "data-name": "Path 4367",
    className: "cls-7",
    d: "M10,17h9.934v8.515H10Z",
    transform: "translate(4.191 7.125)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4368",
    "data-name": "Path 4368",
    className: "cls-4",
    d: "M24,17h8.515v8.515H24Z",
    transform: "translate(10.058 7.125)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4369",
    "data-name": "Path 4369",
    className: "cls-8",
    d: "M25.132,29.2,8.4,17l.7-1.235s15.248,8.685,15.481,8.815a.749.749,0,0,0,.6-.017l15.515-8.841.7,1.233Z",
    transform: "translate(3.519 6.587)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4370",
    "data-name": "Path 4370",
    className: "cls-9",
    d: "M36.828,16.819l-.02.011,0,0-15.38,8.762a2.124,2.124,0,0,1-2.072.129l5.356,7.182,11.713,2.55v.006a2.126,2.126,0,0,0,.88-1.723V16A.945.945,0,0,1,36.828,16.819Z",
    transform: "translate(8.11 6.706)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4371",
    "data-name": "Path 4371",
    className: "cls-10",
    d: "M37.3,31.193V30.146L23.134,22.074l-1.71.975a2.124,2.124,0,0,1-2.072.129l5.356,7.182,11.713,2.55v.006A2.126,2.126,0,0,0,37.3,31.193Z",
    transform: "translate(8.11 9.251)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4372",
    "data-name": "Path 4372",
    className: "cls-11",
    d: "M37.23,31.5,21.7,22.65l-.277.156a2.124,2.124,0,0,1-2.072.131l5.356,7.182,11.713,2.55v.006A2.13,2.13,0,0,0,37.23,31.5Z",
    transform: "translate(8.11 9.493)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4373",
    "data-name": "Path 4373",
    className: "cls-3",
    d: "M8.5,16.837v-.014H8.483l-.043-.028A.922.922,0,0,1,8,16V33.739a2.126,2.126,0,0,0,2.129,2.129h29.8a2.133,2.133,0,0,0,.525-.071.9.9,0,0,0,.255-.085.2.2,0,0,0,.085-.028,1.487,1.487,0,0,0,.326-.184c.028-.014.043-.014.057-.043Z",
    transform: "translate(3.353 6.706)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4374",
    "data-name": "Path 4374",
    className: "cls-11",
    d: "M22.191,32.071V8.892A1.9,1.9,0,0,0,20.3,7H10.881V17.581L8.5,18.94l-.007,0-.017.01A.945.945,0,0,0,8,19.772V33.963H20.3a1.9,1.9,0,0,0,1.892-1.892Z",
    transform: "translate(3.353 2.934)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4375",
    "data-name": "Path 4375",
    className: "cls-12",
    d: "M20.772,33.071V9.892A1.9,1.9,0,0,0,18.88,8h-8v9.162L8.5,18.521l-.007,0-.017.01A.945.945,0,0,0,8,19.353v15.61H18.88A1.9,1.9,0,0,0,20.772,33.071Z",
    transform: "translate(3.353 3.353)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4376",
    "data-name": "Path 4376",
    className: "cls-12",
    d: "M20.772,30.233V9.892A1.9,1.9,0,0,0,18.88,8h-8v9.162L8.5,18.521l-.007,0-.017.01A.945.945,0,0,0,8,19.353V32.125H18.88A1.9,1.9,0,0,0,20.772,30.233Z",
    transform: "translate(3.353 3.353)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4377",
    "data-name": "Path 4377",
    className: "cls-12",
    d: "M19.353,30.233V9.892A1.9,1.9,0,0,0,17.461,8h-6.58v9.162L8.5,18.521l-.007,0-.017.01A.945.945,0,0,0,8,19.353V32.125h9.461A1.9,1.9,0,0,0,19.353,30.233Z",
    transform: "translate(3.353 3.353)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4378",
    "data-name": "Path 4378",
    className: "cls-4",
    d: "M1.892,8H20.814a1.892,1.892,0,0,1,1.892,1.892V28.814a1.892,1.892,0,0,1-1.892,1.892H1.892A1.892,1.892,0,0,1,0,28.814V9.892A1.892,1.892,0,0,1,1.892,8Z",
    transform: "translate(0 3.353)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4379",
    "data-name": "Path 4379",
    className: "cls-13",
    d: "M4.1,14.5a5.933,5.933,0,0,1,2.33-2.574,7.046,7.046,0,0,1,3.7-.928,6.552,6.552,0,0,1,3.424.88,5.875,5.875,0,0,1,2.268,2.459,7.943,7.943,0,0,1,.795,3.619,8.374,8.374,0,0,1-.819,3.783,6.016,6.016,0,0,1-2.334,2.546,6.812,6.812,0,0,1-3.555.9,6.711,6.711,0,0,1-3.5-.89,5.966,5.966,0,0,1-2.3-2.464,7.747,7.747,0,0,1-.8-3.575A8.593,8.593,0,0,1,4.1,14.5Zm2.483,6.043a3.854,3.854,0,0,0,1.31,1.694,3.421,3.421,0,0,0,2.048.617,3.6,3.6,0,0,0,2.187-.637,3.694,3.694,0,0,0,1.273-1.7,6.565,6.565,0,0,0,.406-2.363,7.185,7.185,0,0,0-.383-2.393,3.788,3.788,0,0,0-1.229-1.76,3.387,3.387,0,0,0-2.167-.671,3.538,3.538,0,0,0-2.1.623,3.89,3.89,0,0,0-1.34,1.707,6.778,6.778,0,0,0-.01,4.882Z",
    transform: "translate(1.387 4.609)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4380",
    "data-name": "Path 4380",
    className: "cls-6",
    d: "M0,0H45.411V45.411H0Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgOutlook);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/outlook.a21b0b2811869273e092822549f0a952.svg";